import { matchRoutePath } from '../../../../../shared/frontend/libs/router/router-helpers';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_CHARACTER_RAID_PROGRESS_TIER,
  SET_CHARACTER_RAID_PROGRESS_LOADING,
  SET_CHARACTER_RAID_PROGRESS,
  CLEAR_CHARACTER_MYTHIC_PLUS_PROGRESS
} from '../actions/characterActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { namedRoutes } from '../bundles/routes';
import { decodeSearchParams } from '../../../../../shared/frontend/libs/utils';

const initialState = {
  tier: null,
  loadingRaidProgress: {},
  raidProgress: {},
  loadedRaidProgress: {}
};

export default function characterRaidProgressReducer(state: any = initialState, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_CHARACTER_RAID_PROGRESS_TIER: {
      return {
        ...state,
        tier: action.payload
      };
    }
    case SET_CHARACTER_RAID_PROGRESS_LOADING: {
      return {
        ...state,
        loadingRaidProgress: {
          ...state.loadingRaidProgress,
          [action.payload.tier]: action.payload.loading
        },
        loadedRaidProgress: {
          ...state.loadedRaidProgress,
          [action.payload.tier]: !action.payload.loading
        }
      };
    }
    case SET_CHARACTER_RAID_PROGRESS: {
      return {
        ...state,
        raidProgress: {
          ...state.raidProgress,
          [action.payload.tier]: action.payload.raidProgress
        },
        loadedRaidProgress: {
          ...state.loadedRaidProgress,
          [action.payload.tier]: true
        }
      };
    }
    case LOCATION_CHANGE: {
      // server render may have pre-populated state, so we don't want to nuke it
      if (action.payload.isFirstRendering) {
        const params = decodeSearchParams(action.payload.location.search, { ignoreQueryPrefix: true });
        return state.tier !== params.tier ? { ...state, tier: params.tier } : state;
      }

      const match = matchRoutePath(
        {
          path: namedRoutes.CharacterDetails,
          end: false
        },
        action.payload.location.pathname
      );

      if (match) {
        const params = decodeSearchParams(action.payload.location.search, { ignoreQueryPrefix: true });
        return state.tier !== params.tier ? { ...state, tier: params.tier } : state;
      }

      return initialState;
    }
    case CLEAR_CHARACTER_MYTHIC_PLUS_PROGRESS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
